// There's no difference between page content and page sidebar content. Re-exporting is just for naming purposes.
import PageContent from "../page-content";
export default PageContent;
